import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { BasicInput} from 'core/components';
import {defaultTemplate} from 'core/hoc';

class UserEditPartialForm extends Component {
    render() {
        const {form} = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="form__group col col-lrg-6">
                        <BasicInput field={form.$('firstName')} />
                    </div>
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('lastName')} />
                    </div>
                </div>
                <div className="row">
                    <div className="form__group col col-lrg-6">
                        <BasicInput field={form.$('email')} />
                    </div>
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('displayName')} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

UserEditPartialForm.propTypes = {
    form: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(UserEditPartialForm);